import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon } from 'lucide-react';
import { BRAND_NAME, DELIVERY_CITIES, PHONE_DISPLAY, PHONE_TEL, PRICE_DISCLAIMER } from '../data/site';
import { trackPhoneClick } from '../utils/analytics';
export function SiteFooter() {
  return <footer className="bg-navy-900 pb-24 pt-8 text-steel-400 lg:pb-10" data-id="element-245" data-mp="3hipu41rdoxl1">
      <div className="mx-auto max-w-content px-4 sm:px-6" data-id="element-246" data-mp="3hgddbrxcwt9k">
        <div className="grid grid-cols-1 gap-6 border-t border-white/10 pt-8 md:grid-cols-3" data-id="element-247" data-mp="3dhw492udl8pi">
          <div data-id="element-248" data-mp="38gqcb78jhph1">
            <p className="font-display text-xl font-bold tracking-wide text-white" data-id="element-249" data-mp="38gym2q9d8eo0">{BRAND_NAME}</p>
            <p className="mt-1.5 text-sm" data-id="element-250" data-mp="33jghfc2dsllt">Bovedilla EPS, casetón y vigueta para losa. Pedidos a tu medida.</p>
            <a href={`tel:${PHONE_TEL}`} onClick={() => trackPhoneClick('footer')} className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-white transition-colors duration-150 ease-out hover:text-accent-500" data-id="element-251" data-mp="2ylevmjdkm86n">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-252" data-mp="15q2b6qo678a9" />
              {PHONE_DISPLAY}
            </a>
          </div>
          <div data-id="element-253" data-mp="1ar9fugv0nrcp">
            <h2 className="text-sm font-semibold text-white" data-id="element-254" data-mp="1anlq7ssozp39">Cobertura</h2>
            <p className="mt-1.5 text-sm leading-relaxed" data-id="element-255" data-mp="vuigu8p98hnm">{DELIVERY_CITIES.join(' · ')} y zonas cercanas.</p>
          </div>
          <div data-id="element-256" data-mp="10tljxnlocdsy">
            <h2 className="text-sm font-semibold text-white" data-id="element-257" data-mp="1ohmsgwiuru8d">Privacidad y consentimiento</h2>
            <p className="mt-1.5 text-sm leading-relaxed" data-id="element-258" data-mp="1tg6dmupmh1zo">
              Al enviar tus datos aceptas ser contactado por WhatsApp, teléfono y email para cotización y seguimiento.
              No compartimos tus datos; puedes pedir su baja respondiendo cualquier mensaje.
            </p>
            <Link to="/seguimiento" className="mt-2 inline-block text-sm underline underline-offset-4 transition-colors duration-150 ease-out hover:text-white" data-id="element-259" data-mp="1joa5eqttnvhq">
              Guion de seguimiento (uso interno)
            </Link>
          </div>
        </div>
        <p className="mt-8 border-t border-white/10 pt-5 text-xs leading-relaxed" data-id="element-260" data-mp="2m0jw1yudsc8h">
          {PRICE_DISCLAIMER} Los montos del cotizador son estimados y se confirman por WhatsApp o correo. ©{' '}
          {new Date().getFullYear()} {BRAND_NAME}.
        </p>
      </div>
    </footer>;
}